<!-- 静态数据table -->
<template>
    <div class="container">
        <el-table ref="multipleTable" v-loading="loading" :data="tableData"
                  :header-cell-style="{
        backgroundColor: '#FDEFE7', color: '#000000'
      }"
                  :tree-props="{ children: 'children' }" border default-expand-all row-key="orderChildrenId"
                  style="width: 100%" @select="handleSelectionChange" @select-all="handleSelectionAllChange">
            <el-table-column align="center" type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" label="团号" prop="planId" width="80">
            </el-table-column>
            <el-table-column align="center" label="子订单号" prop="date" width="230">
                <template slot-scope="scope">
                    <div class="tableLine1">
                        <div class="btns1">{{ scope.row.stateName }}</div>
                        <p class="p1">平台操作记录</p>
                    </div>
                    <p class="p2" style="cursor: pointer;text-decoration: underline"
                       @click="openTheOrderDetailsPopUpBox(scope.row.orderChildrenId)">{{
                            scope.row.orderChildrenId
                        }}</p>
                    <p class="p3">{{ scope.row.resourceName ? scope.row.resourceName : scope.row.resourceNameEn }}</p>
                    <!-- <p class="p4">库存供应商:{{ scope.row.stockCompanyId }}</p> -->
                    <p class="p4">
            <span v-if="scope.row.linkName">
              <img src="../assert/城市.png" style="width: 10px;height: 10px"/>
              <span style="margin-left: 2px;color: #dd5827;font-weight: 700">{{ scope.row.linkName }}</span>
            </span>
                        <span v-if="scope.row.mealTextMap && scope.row.state === 4" style="margin-left: 3px">
              <img src="../assert/餐饮.png" style="position: relative;top: 2px;width: 12px;height: 12px"/>
              <span style="margin-left: 2px;color: #dd5827;font-weight: 700">{{ scope.row.mealTextMap.mealText }}</span>
            </span>
                    </p>
                    <p class="p5">{{ scope.row.stockCompanyName }}</p>

                    <p v-if="scope.row.createName" class="p2">{{ scope.row.createName }}</p>
                    <div v-if="scope.row.associatedListMap"
                         style="display: flex;align-items: center;justify-content: center;">
                        <!-- <el-button
                          @click="similarProductsClick(scope.row.associatedListMap, Object.keys(scope.row.associatedListMap)[0])"
                          type="primary" size="mini" class="btns2">{{ btnMap[Object.keys(scope.row.associatedListMap)[0]]
                          }}</el-button> -->
                        <div
                            v-if="(scope.row.orderType === 1 || scope.row.orderType === 5) && scope.row.associatedListMap['ORDER_CONFIRMED'] && scope.row.associatedListMap['ORDER_CONFIRMED'].length > 0">
                            <p style="color: #000;">你选择的资源如下:</p>
                            <p v-for="(n, m) in duplicateRemoval(scope.row.associatedListMap['ORDER_CONFIRMED'], 'resourceId') "
                               :key="m" class="p6">{{
                                    n.resourceName ?
                                        n.resourceName : n.resourceNameEn
                                }}</p>
                        </div>
                        <div v-else>
              <span v-for="(n, m) in Object.keys(scope.row.associatedListMap)" :key="m">
                <span v-if="btnMap[n]" class="btns2"
                      @click="similarProductsClick(scope.row.associatedListMap, n, scope.row)">{{
                        btnMap[n]
                    }} <i class="el-icon-arrow-right" style="font-weight: bold;"></i> </span>
              </span>
                        </div>
                    </div>
                    <div
                        v-if="(scope.row.orderType === 5 || scope.row.orderType === 1) && (!scope.row.associatedListMap || !scope.row.associatedListMap['ORDER_CONFIRMED'] || !scope.row.associatedListMap['ORDER_CONFIRMED'].length)"
                        style="margin-bottom: 0.1rem">
                        <el-button size="mini" type="primary" @click="selectResources(scope.row)">选择资源</el-button>
                    </div>
                    <span v-if="scope.row.listByStockListResults && scope.row.listByStockListResults.length > 0"
                          class="btns2"
                          style="display: inline-block;"
                          @click="handlerStockClick(scope.row.listByStockListResults, scope.row.orderChildrenId)">
            商品变更 点击查看
          </span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="商品" prop="name" width="210">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.orderListDetailResultList" :key="index" class="tableLine2">
                        <p class="p1">
                            <span class="span1">{{ item.number }} {{ item.priceCompany }}</span>
                            <span v-if="item.productName && item.productName !== '0'" class="span2"
                                  @click="openOrderSnapshot(scope.row, item)">{{ item.productName }}</span>
                        </p>
                        <p class="p1">
              <span v-if="item.stockId != 0" class="span2" style="font-weight: 400;color: #333333;">{{
                      item.stockId
                  }} </span>
                        </p>
                        <p class="p1" style="margin-bottom: 0;">
                            <span class="span1">{{ item.number }} {{ item.priceCompany }}</span>
                            <span v-if="scope.row.state === 0" class="span4">{{
                                    item.startTime
                                }}-{{ addOneDay(item.endTime) }}</span>
                            <span v-else-if="item.startTime === item.endTime" class="span4">{{ item.startTime }}</span>
                            <span v-else class="span4">{{ item.startTime }}-{{ item.endTime }}</span>
                        </p>
                        <p class="p3">
                            <!-- [标准价] 早餐2份 果盘一份 3晚 3间 入住当天23:00前免费取消 -->
                        </p>
                        <!-- <div v-if="index != scope.row.orderListDetailResultList.length - 1" class="line"></div> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="单元（元）*数量 *汇率 " prop="address" width="100">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.orderListDetailResultList" :key="index" class="tableLine3">
                        <p class="p1">{{ item.currency }}{{ item.price }}/{{ item.priceCompany }}<span
                            v-if="item.useTime">/</span>
                            {{
                                item.useTime
                            }}</p>
                        <p class="p2">{{ item.number + item.priceCompany }} {{
                                days(item.startTime, item.endTime, scope.row.state) +
                                1
                            }}{{
                                item.useTime ? item.useTime : '天'
                            }}</p>
                        <p v-if="item.rate != 1" class="p3">
                            <span style="color:  #5F6266;"> 汇率：{{ item.rate }} </span>
                            <!-- <span style="color: #5F6266;">{{ item.totalPrice}}</span><span class="span1">¥</span> -->
                        </p>
                        <p v-if="item.cancelNumber > 0" class="lp4">已取消的数量：{{ item.cancelNumber }}</p>
                        <!-- <div v-if="index != scope.row.orderListDetailResultList.length - 1" class="line"></div> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="商品总价（元）" prop="name" width="100">
                <template slot-scope="scope">
                    <div class="tableLine4">
                        <p class="p1" style="margin-bottom: 0;">{{
                                totalPrice(scope.row.orderListDetailResultList)
                            }}￥</p>
                        <p v-if="dataType == 1">利润：<span style="color: red;">{{
                                profitPrice(scope.row.tbudgetDetails)
                            }}¥</span></p>
                        <!-- <p>-30.00</p>
                        <p>满300减20</p>
                        <p>满600减10</p> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column :min-width="operationWidth" fixed="right" label="订单状态及操作" prop="address">
                <template slot-scope="scope">
                    <div v-if="scope.row.truncationResult && isOperation" class="tableLine4"
                         style="width: 100%;display: flex;align-items: center;padding-left: 0.5rem;">
                        <bookState :allDatas="scope.row" :dataType="dataType" :datas="scope.row.truncationResult"
                                   :orderChildrenId="scope.row.orderChildrenId"
                                   :orderMainId="scope.row.orderMainId"
                                   :totalPrice="totalPrice(scope.row.orderListDetailResultList)"
                                   @handlerSeeConfirm="handlerSeeConfirm"
                                   @openPay="openPay"
                                   @updateList="updateList">
                        </bookState>
                        <el-button v-if="scope.row.approvalProcessMapResult" size="mini"
                                   style="margin-left: 0.2rem" type="success"
                                   @click="approvalDetails(scope.row.orderMainId)">审批详情
                        </el-button>
                        <!-- <el-button @click="$emit('openModifyPopup')"
                            >调整订单即金额</el-button
                          >
                          <el-button @click="handlerCloseBookPopup">申请关闭订单</el-button> -->
                    </div>
                    <div v-else>
                        <el-button class="btns3" size="mini" type="primary"
                                   @click="confirmOrderPlacement(scope.row)">确认下单
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <closeBookPopup ref="closeBookPopup"></closeBookPopup>
        <similarProductsPopup v-if="isOperation" ref="similarProductsPopup"></similarProductsPopup>
        <resourceSelection ref="resourceSelection" @updateList="updateList"></resourceSelection>
        <createAVehicleOrder ref="createAVehicleOrder" detection></createAVehicleOrder>
        <orderPageSnapshot ref="orderPageSnapshot"></orderPageSnapshot>
        <resourceSelectionNew ref="resourceSelectionNew" @updateList="updateList"></resourceSelectionNew>
        <el-drawer :data="tableData" :visible.sync="drawer" append-to-body direction="rtl" title="审批详情">
            <div style="padding: 0.1rem;">
                <div
                    v-for="(items, indexs) in approvalData"
                    :key="indexs"
                    style="padding: 0.2rem;margin-bottom: 0.3rem;position: relative;box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;">
                    <el-button v-if="items.applyFlag != 1" :loading="isLoading" size="small"
                               style="position: absolute;right: 0.2rem;top: 0.2rem;" type="primary"
                               @click="auditing(items)">{{
                            items.applyFlag == 0 ? '催审' : '重新发起审核'
                        }}
                    </el-button>
                    <div style="margin-bottom: 0.2rem;">
                        <p style="font-weight: bold;font-size: 0.18rem;margin-bottom: 0.05rem;">发起人：<span>{{
                                items.createName
                            }}</span>
                        </p>
                        <p style="font-weight: bold;font-size: 0.18rem;margin-bottom: 0.05rem;">发起审核时间：<span>{{
                                items.createTime |
                                    dateFormatHms
                            }}</span>
                        </p>
                        <p style="font-weight: bold;font-size: 0.18rem;margin-bottom: 0.05rem;">发起人公司：<span>{{
                                items.createCompanyName
                            }}</span></p>
                        <p style="font-weight: bold;font-size: 0.18rem;margin-bottom: 0.05rem;">审核状态：
                            <el-tag
                                :type="items.applyFlag == 1 ? 'success' : items.applyFlag == 2 ? 'error' : 'info'">{{
                                    approvalMap[items.applyFlag]
                                }}
                            </el-tag>
                        </p>
                    </div>
                    <div v-for="(item, index) in items.stepApprovalProcessResults" :key="index" style="display: flex;">
                        <div style="display: flex;align-items: center;flex-direction: column;">
                            <div :class="{ 'active': item.statusText === '审批通过' }"
                                 style="height: 0.35rem;width: 0.35rem;display: flex;border: 2px solid #C1C4CB;border-radius: 50%;justify-content: center;font-size: 0.22rem;font-weight: bold;color: #C1C4CB;">
                                {{ item.step }}
                            </div>
                            <div v-if="index !== items.stepApprovalProcessResults.length - 1"
                                 style="min-height: 0.7rem;width: 1px;border-right: 2px solid #C1C4CB;flex: 1;">
                            </div>
                        </div>
                        <div style="margin-left: 0.2rem;font-size: 0.18rem;margin-top: 0.05rem;">
                            <p style="margin-bottom: 0.1rem;">审核人名称：{{
                                    item.applyName ? item.applyName :
                                        item.approvalProcessResultList.map(n => n.applyName).join("、")
                                }}
                            </p>
                            <el-tag
                                :type="item.statusText === '审批通过' ? 'success' : item.statusText === '审批驳回' ? 'error' : 'info'"
                                style="margin-bottom: 0.1rem;">
                                {{
                                    item.statusText
                                }}
                            </el-tag>

                            <div v-if="item.returnMsg && item.returnMsg.length > 0"
                                 style="display: flex;font-size: 0.16rem;color: #5F6266">
                                <p>驳回理由:</p>
                                <div>
                                    <p v-for="(remark, m) in item.returnMsg" :key="m"> {{ remark }}</p>
                                </div>
                            </div>
                            <div v-if="item.applyName && item.applyTime">
                                <p style="font-size: 0.13rem;">审核执行人：{{ item.applyName }}</p>
                                <p style="font-size: 0.13rem;">审核时间：{{ item.applyTime }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
        <orderDetailsPopUpBox ref="orderDetailsPopUpBox"></orderDetailsPopUpBox>
    </div>
</template>

<script>
import closeBookPopup from "./closeBookPopup.vue";
import bookState from "./bookState.vue";
import similarProductsPopup from "./similarProductsPopup.vue";
import {days, addOneDay, duplicateRemoval, uniqueByProperty, getGroup, conversionDate} from '@/assets/utils/unit'
import OrderApi from "@/components/Api/order";
import ApplyApi from "@/components/Api/apply"
import resourceSelection from "./resourceSelection.vue";
import createAVehicleOrder from "../../../../plan/leftMoudle/dialog/createAVehicleOrder.vue";
import orderPageSnapshot from "./orderPageSnapshot.vue";
import resourceSelectionNew from "@/views/mechanism/components/myDealChild/child/resourceSelectionNew.vue";
import PayApi from "@/components/Api/pay";
import orderDetailsPopUpBox from "@/views/mechanism/components/myDealChild/child/orderDetailsPopUpBox.vue";

export default {
    props: {
        tableData: {
            type: Array,
            default: []
        },
        loading: {
            type: Boolean,
            default: true
        },
        dataType: {
            default: 0
        },
        isOperation: {
            type: Boolean,
            default: true
        },
        operationWidth: {
            type: Number,
            default: 530
        }
    },
    components: {
        orderDetailsPopUpBox,
        closeBookPopup,
        bookState,
        similarProductsPopup,
        resourceSelection,
        createAVehicleOrder,
        orderPageSnapshot,
        resourceSelectionNew
    },
    data() {
        return {
            orderSelectedData: [],
            days,
            addOneDay,
            duplicateRemoval,
            drawer: false,
            isLoading: false,
            approvalMap: {
                0: '审核中...',
                1: '审核通过',
                2: '审核驳回'
            },
            rowData: {},
            approvalData: [],
            btnMap: {
                'INSUFFICIENT_QUANTITY_AND_TIME': '时间数量已有变化',
                'SIMILAR_PRODUCTS': '已有类似商品',
                'ACCEPTABLE_PRICE': false,
                'ORDER_CONFIRMED': false
            }
        };
    },
    computed: {
        //计算总价钱
        totalPrice() {
            return function (arr) {
                let price = 0
                arr.forEach(n => {
                    price += n.price * n.number * n.rate * (this.days(n.startTime, n.endTime) + 1)
                });
                return price.toFixed(2)
            }
        },
        //总利润
        profitPrice() {
            return function (arr) {
                if (!arr) {
                    return 0
                }
                let price = 0
                arr.forEach(n => {
                    price += (n.ratio - n.stockPrice) * n.stockNumber * (n.rate || 1)
                });
                return price.toFixed(2)

            }
        },
    },
    watch: {
        tableData: {
            handler(newVal) {
                this.$nextTick(() => {
                    this.orderSelectedData.forEach(items => {
                        const idx = newVal.findIndex(item => item.orderChildrenId === items.orderChildrenId);
                        if (idx !== -1) {
                            this.$refs.multipleTable.toggleRowSelection(this.tableData[idx], true);
                        }
                    })
                })
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        openTheOrderDetailsPopUpBox(id) {
            this.$refs.orderDetailsPopUpBox.open(id);
        },
        handlerStockClick(listByStockListResults, orderChildrenId) {
            this.$emit('openStockpopup', listByStockListResults, orderChildrenId)
        },
        openPay(val) {
            this.$emit('openPay', val)
        },
        //单选
        handleSelectionChange(rowList, row) {
            console.log("订单选中", row)
            if (this.orderSelectedData.findIndex(n => n.orderChildrenId == row.orderChildrenId) == -1) {
                this.orderSelectedData.push(row)
            } else {
                this.orderSelectedData.splice(this.orderSelectedData.findIndex(n => n.orderChildrenId == row.orderChildrenId), 1)
            }
            this.$emit("orderSelect", this.orderSelectedData)
        },
        //全选
        handleSelectionAllChange(rowList) {
            if (rowList.length > 0) {
                this.orderSelectedData = uniqueByProperty([...this.orderSelectedData, ...rowList], 'orderChildrenId')
            } else {
                this.tableData.forEach(item => {
                    this.orderSelectedData.splice(this.orderSelectedData.findIndex(n => n.orderChildrenId == item.orderChildrenId), 1)
                })
            }
            this.$emit("orderSelect", this.orderSelectedData)
        },
        //打开审批详情
        approvalDetails(orderMainId) {
            new ApplyApi('apply').approvalProcess([orderMainId]).then((res) => {
                if (res.status === 200) {
                    if (res.data.length > 0) {
                        this.approvalData = res.data
                        this.drawer = true
                    } else {
                        this.$message.warning('暂无审批详情')
                    }
                }
            })
        },

        //催审和重新发起审核
        auditing(items) {
            this.isLoading = true
            if (items.applyFlag) {
                this.reAudit(items)
            } else {
                this.urgeReview(items)
            }
        },
        //催审
        urgeReview(items) {
            new ApplyApi("apply").urgeReviewHttp({
                bid: items.bid,
                approvalBusinessId: items.approvalBusinessId
            }).then(res => {
                if (res.status === 200) {
                    this.isLoading = false
                    this.$message.success('催审成功！')
                    this.approvalDetails(items.bid)
                } else {
                    this.isLoading = false
                    this.$message.error(res.statusText)
                }
            })
        },
        //重新发起审核
        reAudit(items) {
            new PayApi("pay").paymentApprovalQuery({orderMainId: items.bid}).then(res => {
                if (res.status === 200) {
                    this.isLoading = false
                    this.$message.success('发起审核成功！')
                    this.approvalDetails(items.bid)
                } else {
                    this.isLoading = false
                    this.$message.error(res.statusText)
                }
            })
        },
        handlerSeeConfirm(val) {
            this.handlerSeeConfirmedItinerary(val)
        },
        //订单快照
        openOrderSnapshot(items, val) {
            if (val.stockId) {
                this.$refs.orderPageSnapshot.initClick(items.orderType, val.stockId, items.resourceName ? items.resourceName : items.resourceNameEn)
            } else {
                alert('该订单没有快照')
            }
        },
        //查看已确认行程
        handlerSeeConfirmedItinerary(val) {
            this.$refs.createAVehicleOrder.initClick(val.orderMainId)
        },
        updateList() {
            this.$emit('updateList')
        },
        //申请关闭订单弹框
        handlerCloseBookPopup() {
            this.$refs.closeBookPopup.dialogVisible = true;
        },
        selectResources(row) {
             let arr = row.orderListDetailResultList.map(item =>  {
                       return {
                           stockId:item.stockId,//库存id
                           number:item.number,//需要数量
                           startTime:conversionDate(item.startTime),//开始时间
                           endTime:addOneDay(item.endTime),//结束时间
                           productName:item.productName,
                       }
                })
             let groupObj = getGroup(arr, 'stockId')
             console.log(groupObj,'了劳斯莱斯了')
             this.$refs.resourceSelectionNew.open(groupObj,row.orderChildrenId)
        },
        similarProductsClick(val, type, data) {
            this.$refs.similarProductsPopup.initClick(val[type])
            // if ((data.orderType === 1 || data.orderType === 5 || data.orderType === 10) && type === 'ACCEPTABLE_PRICE') {
            // } else {
            // }
        },
        //确认下单
        confirmOrderPlacement(val) {
            console.log(val, 'asdasdasdasd');
            this.$confirm('是否下单！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('upLoading', true)
                new OrderApi('order').purchaseOrderId(val.orderChildrenId).then((res) => {
                    if (res.status === 200) {
                        this.$message({
                            type: 'success',
                            message: '下单成功!'
                        });
                        this.$emit('close')
                    }
                })
            })
        }
    },
    created() {
    },
    mounted() {
        console.log(this.tableData, '速度快开始打开打开');
    },
};
</script>
<style>
.el-table__row--level-1 {
    background-color: #f2efef !important;
    /* 需要设置的背景色 */
    box-shadow: rgba(232, 232, 232, 0.16) 0px 1px 4px, rgb(232, 232, 232) 0px 0px 0px 3px;
}
</style>
<style lang="scss" scoped>
/deep/ .el-table th {
    color: black;
}

/deep/ .el-drawer__header {
    font-size: 0.25rem !important;
    font-weight: bold;
}

.active {
    color: #FF0000 !important;
    border-color: #FF0000 !important;
}

.container {
    .tableLine1 {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.05rem;

        .p1 {
            color: #006FFF;
            font-size: 0.12rem;
            font-family: SourceHanSansSC-regular;
        }

        .btns1 {
            width: 40px;
            height: 20px;
            line-height: 20px;
            border-radius: 8px;
            background-color: #DE562C;
            color: rgba(255, 255, 255, 1);
            font-size: 0.12rem;
            text-align: center;
            font-family: PingFang SC;
            margin-right: 0.12rem;
        }


    }

    .btns2 {
        display: flex;
        align-items: center;
        padding: 1px 3px;
        border-radius: 3px;
        background-color: rgba(230, 74, 25, 1);
        text-align: center;
        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        font-family: PingFangSC-regular;
        transform: scale(0.8);
        transform-origin: 0px 0px;
        cursor: pointer;
    }

    .p2 {
        color: #5F6266;
        font-size: 0.12rem;
        font-family: SourceHanSansSC-regular;
        margin-bottom: 0.05rem;
    }

    .p3 {
        color: #006FFF;
        font-size: 0.12rem;
        // font-weight: bold;
        margin-bottom: 0.05rem;
        font-family: SourceHanSansSC-bold;
    }

    .p4 {
        color: #d81b43;
        font-size: 0.12rem;
        font-family: SourceHanSansSC-bold;
        margin-bottom: 0.05rem;
    }

    .p5 {
        color: #d81b43;
        font-size: 0.12rem;
        font-family: SourceHanSansSC-bold;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
        margin-bottom: 0.05rem;
    }

    .p6 {
        color: rgb(255, 0, 234);
        font-size: 0.12rem;
        font-family: SourceHanSansSC-bold;
    }

    .tableLine2 {
        text-align: left;
        border-top: 1px solid #dbdbdb;
        display: flex;
        height: 1.25rem;
        justify-content: center;
        flex-direction: column;

        &:nth-child(1) {
            border: none;
        }

        .p1 {
            margin-bottom: 0.05rem;

            .span1 {
                color: rgba(216, 27, 67, 1);
                font-size: 0.12rem;
                font-family: SourceHanSansSC-bold;
                font-weight: bold;
                margin-right: 0.1rem;

            }

            .span2 {
                margin-right: 0.1rem;
                color: #333333;
                font-size: 0.12rem;
                font-family: SourceHanSansSC-bold;
                font-weight: bold;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }

            .span4 {
                color: #5F6266;
                font-size: 0.12rem;
                font-weight: bold;
                margin-right: 0.1rem;
                font-family: SourceHanSansSC-bold;
            }
        }

        .line {
            border-bottom: 1px solid #dbdbdb;
            margin: 0.06rem 0;
        }
    }

    .tableLine3 {
        text-align: left;
        border-top: 1px solid #dbdbdb;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 1.25rem;

        &:nth-child(1) {
            border: none;
        }

        .p1 {
            color: #FF0000;
            font-size: 0.12rem;
            font-weight: bold;
            font-family: SourceHanSansSC-bold;
            margin-bottom: 0.05rem;
            text-decoration: underline;
        }

        .p3 {
            .span1 {
                color: #FF0000;
                font-size: 0.12rem;
                font-family: SourceHanSansSC-bold;
                font-weight: bold;
            }
        }

        .lp4 {
            font-size: 0.12rem;
            font-weight: bold;
            color: #DCA550;
        }

        .line {
            border-bottom: 1px solid #dbdbdb;
            margin: 0.06rem 0;
        }
    }

    .tableLine4 {
        .p1 {
            color: rgba(216, 27, 67, 1);
            font-size: 0.12rem;
            font-family: SourceHanSansSC-bold;
            font-weight: bold;
        }

        p {
            margin-bottom: 0.05rem;
        }
    }
}
</style>
